import { contentImgListValidation } from 'src/constrains/DraggableModules/tools';
import {
  convertSpecificError,
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from 'src/error/code';
import {
  EColType,
  fixedCollapse,
} from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/common';
import { addDraggableId, reduxUpdatedStatusControl } from 'src/tools/helper';

export const errKey = {
  megaMenuTitle: 'megaMenuTitle',
  megaMenuContentPageInvalid: 'megaMenuContentPageInvalid',
  megaMenuContentPage: 'megaMenuContentPage',
  megaMenuContentPageImage: 'megaMenuContentPageImage',
  megaMenuContentPageSubtitle: 'megaMenuContentPageSubtitle',
  megaMenuContentPageSummary: 'megaMenuContentPageSummary',
};

const generateErrorKey = (name, index?) => {
  return index ? `${name}==${index}` : `${name}`;
};

const splitErrorKey = (name) => {
  return name.split('==');
};

const validateMegaMenu = (menu, contentPages) => {
  const { title, menuColumns } = menu;
  const _generateErrorKeys = () => {
    return ['0', '1', '2', '3'].reduce((pre, now) => {
      const contentPageK = generateErrorKey(errKey.megaMenuContentPage, now);
      const contentPageImageK = generateErrorKey(
        errKey.megaMenuContentPageImage,
        now,
      );
      const contentPageSubtitleK = generateErrorKey(
        errKey.megaMenuContentPageSubtitle,
        now,
      );
      const contentPageSummaryK = generateErrorKey(
        errKey.megaMenuContentPageSummary,
        now,
      );
      const contentPageInvalidK = generateErrorKey(
        errKey.megaMenuContentPageInvalid,
        now,
      );

      return {
        ...pre,
        [contentPageK]: [],
        [contentPageImageK]: [],
        [contentPageSubtitleK]: [],
        [contentPageSummaryK]: [],
        [contentPageInvalidK]: [],
      };
    }, {});
  };
  const specificErr = {
    [generateErrorKey(errKey.megaMenuTitle)]: [],
    ..._generateErrorKeys(),
  };

  if (!title) {
    specificErr[generateErrorKey(errKey.megaMenuTitle)].push(
      errCodesMap[999999],
    );
  }
  (menuColumns || []).forEach((menu, i) => {
    const index = i.toString();
    const { columnType } = menu || {};
    // console.log('columnType', columnType);
    if (EColType.ContentPage === columnType) {
      const { specificError }: any = contentImgListValidation({
        type: 'general',
        list: [menu],
        contentPages: contentPages,
        subTitleRequired: true,
      });
      //console.log('specificError', specificError);

      const {
        contentPage: c,
        contentPageInvalid: cI,
        image: i,
        subtitle: sub,
        summary: sum,
      } = specificError;

      const kPageInvalid = generateErrorKey(
        errKey.megaMenuContentPageInvalid,
        index,
      );

      (specificErr[kPageInvalid] || []).push(...cI);

      const kPage = generateErrorKey(errKey.megaMenuContentPage, index);
      (specificErr[kPage] || []).push(...c);

      const kImage = generateErrorKey(errKey.megaMenuContentPageImage, index);
      (specificErr[kImage] || []).push(...i);

      const kSubtitle = generateErrorKey(
        errKey.megaMenuContentPageSubtitle,
        index,
      );
      (specificErr[kSubtitle] || []).push(...sub);

      const kSummary = generateErrorKey(
        errKey.megaMenuContentPageSummary,
        index,
      );
      (specificErr[kSummary] || []).push(...sum);
    }
  });

  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
  // const _validateContentPage = (contentPage) => {};
};

const convertDataFromServerToRedux = (data) => {
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    megaMenuList,
    salesChannelUuid,
    menuStyle,
  } = data;

  //const { uuid: salesChannelUuid } = salesChannelContent;
  //console.log('salesChannelName', salesChannelName);
  const _isNew = modifiedDate === createdDate;

  const temp = addDraggableId(megaMenuList || []);
  //console.log('temp', temp);
  const _megaMenuList = temp.map((list) => {
    const { menuGroups } = list;
    const _menuGroups = addDraggableId(menuGroups || []);
    return { ...list, menuGroups: _menuGroups };
  });
  const menuIds = _megaMenuList.map((i) => i.draggableId);
  const ids = [...(fixedCollapse || []), ...menuIds];
  const collapseOpen = generateCollapseOpen(ids);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(ids, !_isNew);
  if (hasError) {
    let flag = false;
    _megaMenuList.forEach((list) => {
      const { draggableId } = list;
      const res = validateMegaMenu(list, []);
      const hasError = res.hasError;
      if (!flag && hasError) {
        collapseErrorMsgDisplay[draggableId].hasError = true;
        flag = true;
        collapseOpen[draggableId] = true;
      }
    });
  }

  return {
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    megaMenuList: _megaMenuList || [],
    salesChannelUuid,
    menuStyle,
    ...reduxUpdatedStatusControl,
  };
};

const convertDataFromReduxToServer = (data) => {
  const { contentUuid, uuid, menuStyle, megaMenuList, salesChannelUuid } = data;
  return { contentUuid, uuid, menuStyle, megaMenuList, salesChannelUuid };
};

export {
  validateMegaMenu,
  convertDataFromServerToRedux,
  convertDataFromReduxToServer,
  generateErrorKey,
  splitErrorKey,
};
